<div>
  <fusioncharts
  [width]="width_h"
  [height]="height_h"
  [type]="type_h"
  [dataFormat]="dataFormat_h"
  [dataSource]="dataSource_h"
>
</fusioncharts>
</div>
